import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
// GANTI IMPORT INI:
import axios from '../services/axios'; 

const ResetPassword = () => {
  const [form, setForm] = useState({ 
    password: '', 
    confirmPassword: '' 
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      if (!token) {
        setError('Token reset password tidak valid');
        setLoading(false);
        return;
      }

      if (!form.password || !form.confirmPassword) {
        setError('Password dan konfirmasi password wajib diisi');
        setLoading(false);
        return;
      }

      if (form.password !== form.confirmPassword) {
        setError('Password dan konfirmasi password tidak cocok');
        setLoading(false);
        return;
      }

      if (form.password.length < 6) {
        setError('Password minimal 6 karakter');
        setLoading(false);
        return;
      }

      console.log('🔵 Sending reset password request');

      const res = await axios.post('/auth/reset-password', {
        token,
        password: form.password.trim(),
      });

      console.log('🟢 Reset password response:', res.data);
      setSuccess('Password berhasil direset! Anda akan diarahkan ke halaman login.');

      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 3000);
      
    } catch (err) {
      console.error('❌ Reset password failed:', err.response?.data || err.message);
      const msg = err.response?.data?.message || err.message || 'Terjadi kesalahan. Coba lagi.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={styles.title}>Link Tidak Valid</h2>
          <p style={styles.subtitle}>
            Link reset password tidak valid atau sudah kadaluarsa
          </p>
          <Link to="/forgot-password" style={styles.a}>
            Minta link reset password baru
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Reset Kata Sandi</h2>
        <p style={styles.subtitle}>
          Masukkan password baru Anda
        </p>

        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            name="password"
            placeholder="Password Baru"
            value={form.password}
            onChange={handleChange}
            style={styles.input}
            required
            disabled={loading}
            autoComplete="new-password"
            minLength={6}
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Konfirmasi Password Baru"
            value={form.confirmPassword}
            onChange={handleChange}
            style={styles.input}
            required
            disabled={loading}
            autoComplete="new-password"
            minLength={6}
          />
          <button
            type="submit"
            style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
            disabled={loading}
          >
            {loading ? 'Memproses...' : 'Reset Password'}
          </button>
        </form>

        <p style={styles.link}>
          <Link to="/login" style={styles.a}>
            Kembali ke Login
          </Link>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a3c6d, #4a90e2)',
    fontFamily: '"Segoe UI", sans-serif',
  },
  card: {
    width: 420,
    padding: '40px 30px',
    background: 'white',
    borderRadius: 16,
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    textAlign: 'center',
  },
  title: {
    margin: 0,
    marginBottom: 8,
    fontSize: 28,
    color: '#1a3c6d',
    fontWeight: 'bold',
  },
  subtitle: {
    margin: '0 0 20px',
    color: '#666',
    fontSize: 14,
  },
  input: {
    width: '100%',
    padding: '14px',
    margin: '12px 0',
    borderRadius: 8,
    border: '1px solid #ddd',
    fontSize: 16,
    boxSizing: 'border-box',
    transition: 'border-color 0.3s',
  },
  button: {
    width: '100%',
    padding: '14px',
    background: '#1a3c6d',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: 10,
    transition: 'background 0.3s',
  },
  error: {
    color: '#e74c3c',
    background: '#fadad7',
    padding: '10px',
    borderRadius: 8,
    margin: '10px 0',
    fontSize: 14,
  },
  success: {
    color: '#27ae60',
    background: '#d5f4e6',
    padding: '10px',
    borderRadius: 8,
    margin: '10px 0',
    fontSize: 14,
  },
  link: {
    margin: '20px 0 10px',
    fontSize: 14,
    color: '#555',
  },
  a: {
    color: '#1a3c6d',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};

export default ResetPassword;
